module.exports = __webpack_public_path__ + "static/media/bg-camera.a4f1613e.png";